var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-dialog',{attrs:{"persistent":""},model:{value:(_vm.showSync),callback:function ($$v) {_vm.showSync=$$v},expression:"showSync"}},[_c('q-layout',{staticClass:"bg-white adjust-modal"},[_c('q-page-container',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }